import { render } from "./JudgeOverview.vue?vue&type=template&id=1cf0748b"
import script from "./JudgeOverview.vue?vue&type=script&lang=js"
export * from "./JudgeOverview.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__